import React, { useRef, useState } from "react";
import {
  ContainCategoryCreate,
  FormCard,
  SectionWrapper,
  ColorPicker,
  DefaultColors,
  ColorContainer,
  ButtonContainer,
  ReqFieldMandatory,
} from "./AdminCategoryCreate.styled";
import { ReactComponent as CloseIcon } from "../../../themes/Icons/close_icon.svg";
import { Colorize } from "@material-ui/icons";
import { theme as themeConfig } from "../../../themes/themes";

const AdminCategoryCreate = ({ setClose, createCategoryhandler }) => {
  const [color, setColorPicker] = useState(themeConfig.primary.green);
  const nameCategory = useRef();
  const refColorPicker = useRef();
  let handleColorPicker = (e) => {
    setColorPicker(e.target.value);
  };

  let handleCustomColor = () => {
    refColorPicker.current.click();
  };

  return (
    <ContainCategoryCreate>
      <FormCard>
        <SectionWrapper className="header-wrapper">
          <h1>Create Event Category</h1>
          <CloseIcon
            onClick={() => {
              setClose(false);
            }}
          />
        </SectionWrapper>
        <SectionWrapper>
          <label>
            Category Name<ReqFieldMandatory>*</ReqFieldMandatory>
          </label>
          <input type="text" placeholder="Type Name Here" ref={nameCategory} />
        </SectionWrapper>
        <SectionWrapper>
          <label>
            Choose category color<ReqFieldMandatory>*</ReqFieldMandatory>
          </label>
          <DefaultColors>
            <ColorContainer
              bgcolor={themeConfig.primary.blue}
              onClick={() => setColorPicker(themeConfig.primary.blue)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.tealLight}
              onClick={() => setColorPicker(themeConfig.primary.tealLight)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.orangeLight}
              onClick={() => setColorPicker(themeConfig.primary.orangeLight)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.orangeDeep}
              onClick={() => setColorPicker(themeConfig.primary.orangeDeep)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.redDarkCategory}
              onClick={() => setColorPicker(themeConfig.primary.redDarkCategory)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.indigo}
              onClick={() => setColorPicker(themeConfig.primary.indigo)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.purplePink}
              onClick={() => setColorPicker(themeConfig.primary.purplePink)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.purpleAccent}
              onClick={() => setColorPicker(themeConfig.primary.purpleAccent)}
            />
            <ColorContainer
              bgcolor={themeConfig.primary.green}
              onClick={() => setColorPicker(themeConfig.primary.green)}
            />
          </DefaultColors>
          <ColorPicker>
            <div>
              <Colorize />
              <label onClick={handleCustomColor}>Select a custom color</label>
            </div>
            <ColorContainer bgcolor={color} />
          </ColorPicker>
          <input
            type="color"
            className="color-picker-input"
            defaultValue={color}
            ref={refColorPicker}
            onChange={(e) => handleColorPicker(e)}
          />
        </SectionWrapper>
        <ButtonContainer>
          <button onClick={() => setClose(false)} className="cancel-button">
            Cancel
          </button>
          <button
            type="submit"
            className="create-button"
            onClick={() =>
              createCategoryhandler(nameCategory.current.value, color)
            }
          >
            Create
          </button>
        </ButtonContainer>
      </FormCard>
    </ContainCategoryCreate>
  );
};

export default AdminCategoryCreate;
